import React from "react";
import { Box, Marquee, Text } from "retro-react";
import './Contact.css'
import { fetchContact } from "../../api/contact";
import { useApi } from "../../hooks/useApi";
import { LoadingBox } from "../../components/LoadingBox";

const Contact = () => {
    const { output, loading, error } = useApi(fetchContact);

    if (loading) {
        return (
            <div className="loading-wrapper">
              <LoadingBox/>
            </div>
          )    }
    
    if (error) {
        return <p>Error loading data.</p>;
    }
    const contactJSON = output[0]; //select first value

    const aEmail = contactJSON?.acf?.email;
    const aPhone = contactJSON?.acf?.phone;
    const aMarquee = contactJSON?.acf?.marquee_text


    return(
        <div className="box-container">
            <Box className="contact-box">
                <div className="text-box">
                    <Text className="text-items" variant="h2" align="center"> 
                        {aEmail};
                    </Text>
                    <Text className="text-items" variant="h2" align="center">
                       <br/> {aPhone} 
                    </Text>
                </div>
            </Box> 
            <Marquee
                className="marquee-text"
                color="#000000"
                gap="1rem"
                size="large"
                speed="45s"
            >
            {aMarquee}
            </Marquee>
        </div>
 

    );
}

export default Contact